import { render, staticRenderFns } from "./materialIndustrial.vue?vue&type=template&id=73656a4a&scoped=true&"
import script from "./materialIndustrial.vue?vue&type=script&lang=js&"
export * from "./materialIndustrial.vue?vue&type=script&lang=js&"
import style0 from "./materialIndustrial.vue?vue&type=style&index=0&id=73656a4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73656a4a",
  null
  
)

export default component.exports